import React from "react";
import IserbaValidationStep from "../iserba/IserbaValidationStep";

const ValidationStep = ({
	quizOrganizationId,
	player,
	onChangePlayer,
	onEditAvatar,
	onValidatePlayer,
}) => {
	// If using Iserba, show their specific validation step
	if (quizOrganizationId === "1af3a66b-316d-4be0-8332-eb7bc15f4e27") {
		return (
			<IserbaValidationStep
				player={player}
				onChangePlayer={onChangePlayer}
				onEditAvatar={onEditAvatar}
				onValidatePlayer={onValidatePlayer}
			/>
		);
	}

	// Default Validation UI
	return (
		<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
				Est-ce bien vous?
			</h1>

			{/* Display Player Attributes Dynamically */}
			<div className="bg-gray-100 p-4 rounded-lg shadow-md w-full max-w-sm">
				{player?.email && (
					<p className="text-gray-700">
						<strong>Email:</strong> {player.email}
					</p>
				)}
				{player?.pseudo && (
					<p className="text-gray-700">
						<strong>Pseudo:</strong> {player.pseudo}
					</p>
				)}
				{player?.avatar && (
					<div className="flex flex-col items-center mt-2">
						<img
							src={player.avatar}
							alt="Avatar"
							className="w-20 h-20 rounded-full border mt-2"
						/>
					</div>
				)}
			</div>

			<div className="flex flex-col gap-2 items-center mt-8">
				<button
					onClick={onValidatePlayer}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Oui!
				</button>
				<button
					onClick={onChangePlayer}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#adadad] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#9d9d9d] disabled:bg-slate-300"
				>
					Non, changer de profil
				</button>
			</div>
		</div>
	);
};

export default ValidationStep;
